import { v2Api } from '../v2Api';

const tags = ['workspace'] as const;

const workspaceApi = v2Api
  .enhanceEndpoints({
    addTagTypes: tags,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getWorkspaces: builder.query<string[], { projectId: number; emrId: number }>({
        query: ({ projectId, emrId }) => `projects/${projectId}/emrs/${emrId}/notebooks`,
        providesTags: tags,
        transformResponse: (response: { data: string[] }) => response.data,
      }),
      getWorkspaceFiles: builder.query<string[], { projectId: number; emrId: number; workspaceId: string }>({
        query: ({ projectId, emrId, workspaceId }) =>
          `projects/${projectId}/emrs/${emrId}/notebooks/${workspaceId}/files`,
        providesTags: tags,
        transformResponse: (response: { data: string[] }) => response.data,
      }),
    }),
  });

export default workspaceApi;
